<p i18n="@@shared.norecordsfound">No records found</p>
<p i18n="@@shared.addrecords.clickplusbutton">To add records, click the "+" button</p>
<p *ngIf="isAddOpenInNewTab" i18n="@@onceaddedreturntothisscreenandclicktherefreshbutton">
  Once added, return to this screen and click the refresh button
</p>
